module.exports = __webpack_public_path__ + "static/media/logo_or.57023ac9.PNG";